import { HighlightBannerPosterForm } from './HighlightBannerPosterForm'
import { withHighlightBannerPosterForm } from './withHighlightBannerPosterForm'

const Connected = withHighlightBannerPosterForm(HighlightBannerPosterForm)

export { Connected as HighlightBannerPosterForm }
